import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import '../App.scss';

const NavigationBar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isMobileNav = () => window.innerWidth <= 991;

  /** Skini focus sa nav linkova da hover opet radi na svim tabovima */
  const blurNavFocus = (event?: React.MouseEvent<HTMLElement>) => {
    const target = event?.currentTarget as HTMLElement | undefined;
    if (target && typeof target.blur === 'function') {
      target.blur();
    }
    const active = document.activeElement as HTMLElement | null;
    if (active && active.classList.contains('nav-link')) {
      active.blur();
    }
  };

  const handleNavItemClick = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    targetId: string
  ) => {
    event.preventDefault();
    blurNavFocus(event);

    const waitForMenu =
      isMobileNav() && (targetId === '#nagrade' || targetId === '#mehanizam');

    const go = () => {
      if (location.pathname !== '/') {
        navigate('/');
        setTimeout(() => {
          scrollToTarget(targetId);
        }, 50);
      } else {
        scrollToTarget(targetId);
      }
    };

    if (waitForMenu) {
      closeMobileMenu();
      setTimeout(go, 350);
      return;
    }

    go();
    closeMobileMenu();
  };

  const scrollToTarget = (targetId: string) => {
    const mobile = isMobileNav();
    const selector =
      mobile && targetId === '#nagrade' ? '#glavna-nagrada' : targetId;
    const targetElement = document.querySelector(selector);

    if (targetElement) {
      let yOffset = -70;
      if (targetId === '#lista-dobitnika') {
        yOffset = mobile ? -500 : -150;
      } else if (mobile && (targetId === '#nagrade' || targetId === '#mehanizam')) {
        yOffset = -80;
      }

      const y =
        targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }
  };

  const closeMobileMenu = () => {
    const navbarToggler = document.querySelector('.navbar-toggler') as HTMLElement;
    const navbarCollapse = document.querySelector('.navbar-collapse') as HTMLElement;

    if (navbarToggler && navbarCollapse && navbarCollapse.classList.contains('show')) {
      navbarToggler.click(); // Aktiviramo Bootstrap logiku za zatvaranje
    }
  };

  const handleLogoClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.preventDefault();
    blurNavFocus();
    closeMobileMenu();

    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 50);
      return;
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Navbar bg="primary" variant="dark" expand="lg" sticky="top" className="custom-navbar">
      <Container>
                {/* Logo Firebird-a */}
          <Navbar.Brand href="/" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
            <img
              src="/ultra-logo-2025.png"
              alt="Ultra Energy Drink"
              style={{ width: '120px', height: 'auto' }}
            />
               {/* <span style={{ fontSize: '1rem', fontWeight: 'bold', color: '#e07415' }}>
                FIREBIRD
              </span> */}
          </Navbar.Brand> 
        {/* Tekst za mobilnu verziju */}
        {/* <div className="navbar-brand-text d-flex flex-column align-items-start d-lg-none d-md-none">
          <h1 className="text-uppercase mb-0 zgrabi-text">ZGRABI<span className="ultra-text">ULTRA</span></h1> 
          <h1 className="text-uppercase zgrabi-text">NAGRADE</h1>
        </div> */}

        <Navbar.Toggle aria-controls="basic-navbar-nav" className="ms-auto" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center">
          <Nav className="nav-links">
          <Nav.Link
            href="/prijava"
            className="nav-link"
            onClick={(e) => {
              e.preventDefault();
              blurNavFocus(e);
              navigate('/prijava');
              closeMobileMenu();
            }}
          >
            PRIJAVI SE
          </Nav.Link>
            <Nav.Link
              href="#mehanizam"
              className="nav-link"
              onClick={(e) => handleNavItemClick(e, '#mehanizam')}
            >
              MEHANIZAM
            </Nav.Link>
            <Nav.Link
              href="#nagrade"
              className="nav-link"
              onClick={(e) => handleNavItemClick(e, '#nagrade')}
            >
              NAGRADE
            </Nav.Link>
            <Nav.Link
              href="#lista-dobitnika"
              className="nav-link"
              onClick={(e) => handleNavItemClick(e, '#lista-dobitnika')}
            >
              DOBITNICI
            </Nav.Link>
            <Nav.Link
              href="#pravila-kontakt"
              className="nav-link"
              onClick={(e) => handleNavItemClick(e, '#pravila-kontakt')}
            >
              PRAVILA
            </Nav.Link>
            <Nav.Link
              href="#pravila-kontakt"
              className="nav-link"
              onClick={(e) => handleNavItemClick(e, '#pravila-kontakt')}
            >
              KONTAKT
            </Nav.Link>
            {/* <Nav.Link
              href="#zapocni-kviz"
              className="nav-link"
              onClick={(e) => handleNavItemClick(e, '#zapocni-kviz')}
            >
              KVIZ
            </Nav.Link> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
